

















import { Component, Prop, Vue } from 'vue-property-decorator';
@Component
export default class MedicineImage extends Vue {

    @Prop() private isLoadCompleted!: boolean;
    @Prop() private imageWidth!: number;
    @Prop() private imageHeight!: number;
    @Prop() private isEmphasized!: boolean;
    @Prop() private doseAmount!: number;
    @Prop() private imagePath!: string;


    get showHalfMask(): boolean {
        return !this.isEmphasized && this.doseAmount === 0.5;
    }

    get showQuaterMask(): boolean {
        return !this.isEmphasized && this.doseAmount === 0.25;
    }
}
